import React from 'react';
import logo from '../images/logo-footer.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <img src={logo} alt="Be Safe Keep Safe Logo" className="logo-img" />
              </div>
              <span className="logo-text">Be Safe Keep Safe</span>
            </div>
            <p className="footer-description">
              Professional health and safety consultancy services for businesses of all sizes. 
              Creating safer work environments through expert guidance and comprehensive risk assessments.
            </p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>Home</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <span className="contact-icon">📞</span>
                <a href="tel:07707711092">07707711092</a>
              </li>
              <li>
                <span className="contact-icon">✉️</span>
                <a href="mailto:bsks@besafekeepsafe.co.uk">bsks@besafekeepsafe.co.uk</a>
              </li>
              <li>
                <span className="contact-icon">👤</span>
                <span>Mohammed Abid</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Be Safe Keep Safe. All rights reserved.</p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
